<template>
    <div>
      <newsbanner></newsbanner>
      <newstable></newstable>
    </div>
</template>

<script>
  // import newscontent from "@/components/contentcoms/newscontentcoms/newscontent";
  import newsbanner from "@/components/contentcoms/newscontentcoms/newsbanner";
 import newstable from "@/components/contentcoms/newscontentcoms/newstable";
  export default {
      name: "news",
    components: {newsbanner,newstable}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/news.vue